import { render, staticRenderFns } from "./AboutComponent.vue?vue&type=template&id=370c1aad&scoped=true"
import script from "./AboutComponent.vue?vue&type=script&lang=js"
export * from "./AboutComponent.vue?vue&type=script&lang=js"
import style0 from "./AboutComponent.vue?vue&type=style&index=0&id=370c1aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370c1aad",
  null
  
)

export default component.exports